import React, { useEffect, useState } from "react";
import { DivTag, PTag, Button } from "../../Components/Tags/Tags";
import Header from "../../Components/Header";
import {
  AddIPService,
  IPRetriveService,
  ToggleStatusService,
} from "../../Services/AddBankAC.js/IpService";
import { fetchProfile } from "../../Services/profile/profileservice";
import { FaInbox } from "react-icons/fa";
import moment from "moment";
import Seo from "../../Components/SeoComponent/Seo";
import ConfirmPopUp from "../../Components/ConfirmPopUp/ConfirmPopUp";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import Loader from "../../Loader";
import { IoIosCopy } from "react-icons/io";
import { Info, Key } from "lucide-react";
import APIKeyChangeModal from "./APIKeyChangeModal";

const WhiteListIP = () => {
  const [ipAddress, setIpAddress] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [isWhitelisted, setIsWhitelisted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ipAddressData, setIpAddressData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [profile, setProfile] = useState(null);
  const [changeKeyClicked, setChangeKeyClicked] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await fetchProfile();
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfileData();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setIpAddress(value);
    setIsValid(value.length >= 5); // Validate IP length for simplicity
  };

  const handleWhitelist = async () => {
    if (isValid) {
      await addIPAddress(); // Wait for the IP address to be added
      await ipAddressDataRetrieve();
    }
  };

  // Add IP Service
  const addIPAddress = async () => {
    try {
      setIsLoading(true);
      const response = await AddIPService({ ip_address: ipAddress });
      if (response.status == 422) {
        // return showErrorToast(response.data.errors.ip_address[0])
        return showErrorToast(response.data.message);
      }
      setIpAddress("");
      showSuccessToast(
        response.message || "IP has been successfully whitelisted",
      );
      setIsLoading(false);
      await ipAddressDataRetrieve();
      return;
    } catch (error) {
      setIsLoading(false);
      return showErrorToast(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Retrieve IP Data
  const ipAddressDataRetrieve = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const response = await IPRetriveService(page);
      setIpAddressData(response?.data);
      setPaginationData(response?.pagination);
      setCurrentPage(response?.pagination?.current_page);
      setLastPage(response?.pagination?.last_page);
    } catch (error) {
      showErrorToast("Error fetching IP address data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Use Effect for Initial Data Fetch
  useEffect(() => {
    ipAddressDataRetrieve(); // Fetch data on component mount and page change
  }, [currentPage]);

  // Toggle Status Service
  const toggleStatus = async () => {
    try {
      const response = await ToggleStatusService({ ip_id: selectedId });
      await ipAddressDataRetrieve(currentPage); // Refresh data after status change
    } catch (error) {
      console.error("Error toggling status:", error);
    } finally {
      closeModal(); // Close modal after status change
    }
  };

  // Modal Handling
  const openModal = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedId(null);
  };

  const handleCopy = (tokenId) => {
    if (!tokenId) {
      showErrorToast("No ID available to copy!");
      return;
    }

    // Create a temporary textarea to copy the text
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = tokenId; // Set the value to the passed tokenId
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    // Show success message
    showSuccessToast("Copied to clipboard!");
  };

  const handleCopyID = (tokenId) => {
    if (!tokenId) {
      showErrorToast("No User ID available to copy!");
      return;
    }
    // Create a temporary textarea to copy the text
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = tokenId; // Set the value to the passed tokenId
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    // Show success message
    showSuccessToast("Copied to clipboard!");
  };

  const handleCopyKey = (tokenId) => {
    if (!tokenId) {
      showErrorToast("No User ID available to copy!");
      return;
    }
    // Create a temporary textarea to copy the text
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = tokenId; // Set the value to the passed tokenId
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    // Show success message
    showSuccessToast("Copied to clipboard!");
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <ConfirmPopUp
        onConfirm={toggleStatus}
        visible={showModal}
        onClose={closeModal}
        title="Are you Sure Want to Submit"
      />
      <DivTag className="text-center">
        <Header heading="WhiteList your Server IP to use API" />
        <DivTag className="text-center ">
          <div className=" w-full flex items-center gap-2 justify-center">
            <div className="bg-green-50  my-3 w-fit border border-green-600 text-green-600 rounded-lg px-3 py-6">
              <div className="flex items-center">
                <p className="flex items-center gap-2 capitalize">
                  <strong className="flex items-center gap-2 ">
                    <Info /> Api key security
                  </strong>{" "}
                  Never share your api keys in public repositories or client
                  side code.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row w-full items-center justify-center gap-3">
            {/* Modernized IP Address Input */}
            <input
              type="text"
              id="ipAddress"
              name="ipAddress"
              placeholder="Enter IP Address"
              value={ipAddress}
              onChange={handleInputChange}
              className={`px-3.5 py-2 text-sm text-black placeholder-slate-400 bg-slate-100/60 rounded-lg border transition-all duration-200 outline-none focus:ring-2 ${
                isValid
                  ? "border-slate-700/80 focus:border-blue-500 focus:ring-blue-500/20"
                  : "border-red-500/80 text-red-300 focus:border-red-500 focus:ring-red-500/20"
              }`}
            />

            {/* Actions */}
            <div className="flex items-center gap-2">
              {/* Primary Action */}
              <Button
                type="button"
                onClick={handleWhitelist}
                disabled={!isValid}
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white transition-all duration-200 rounded-lg bg-blue-600 hover:bg-blue-500 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none disabled:hover:bg-blue-600 shadow-sm shadow-blue-500/20"
              >
                Whitelist
              </Button>

              {/* Secondary Action */}
              <Button
              onClick={() => setChangeKeyClicked(true)}
                type="button"
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-slate-200 transition-all duration-200 rounded-lg bg-green-600 hover:bg-slate-700/80 hover:text-white active:scale-[0.98] border border-slate-700/60 shadow-sm"
              >
                <Key size={18} />
                Change API Key
              </Button>
            </div>
          </div>
        </DivTag>

        {!isValid && (
          <PTag
            className="text-red-600"
            text="IP address must be at least 5 characters."
          />
        )}

        {isWhitelisted && (
          <>
            <PTag
              className="text-green-600"
              text="IP address successfully whitelisted!"
            />
          </>
        )}

        <>
          {ipAddressData && ipAddressData.length > 0 ? (
            <>
              {/* Desktop Table */}
              <div className="overflow-x-auto hidden md:block">
                <div className="flex justify-end md:gap-1 gap-1 text-xs">
                  <span className="text-red-400 mt-2 text-xl">
                    You can only mark one IP Address as active at a time for the
                    API Access.
                  </span>
                  <span className="font-bold rounded-md shadow-inner shadow-blue-500 p-1">
                    User ID{" "}
                    <p className="font-semibold">
                      {profile?.user_id}
                      <IoIosCopy
                        className="inline text-green-800"
                        onClick={() => handleCopyID(profile?.user_id)}
                        size={20}
                      />
                    </p>
                  </span>
                  <span className="font-bold rounded-md shadow-inner shadow-blue-500 p-1">
                    API Key{" "}
                    <p className="font-semibold">
                      {profile?.api_key}
                      <IoIosCopy
                        className="inline text-green-800"
                        onClick={() => handleCopyKey(profile?.api_key)}
                        size={20}
                      />
                    </p>
                  </span>
                </div>

                <table
                  id="table"
                  className="min-w-full divide-y divide-gray-200"
                >
                  <thead>
                    <tr className="bg-blue-900 text-center text-white">
                      <th className="border-2 md:p-1 p-0">Sno</th>
                      <th className="border-2">IP Address</th>
                      <th className="border-2">Created At</th>
                      <th className="border-2">Updated At</th>

                      <th className="border-2">Token ID</th>
                      <th className="border-2">Description</th>
                      <th className="border-2">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ipAddressData?.map((item, index) => (
                      <tr
                        key={(currentPage - 1) * lastPage + index + 1}
                        className="text-center"
                      >
                        <td className="border shadow-inner shadow-blue-600 px-1">
                          {(currentPage - 1) * paginationData?.per_page +
                            index +
                            1}
                        </td>
                        <td className="border shadow-inner shadow-blue-400 font-bold text-sm md:text-md px-1">
                          {item?.ip_address}
                        </td>
                        <td className="border shadow-inner shadow-blue-400 px-1">
                          {moment(item?.created_at).format("YYYY/MM/DD")}
                        </td>
                        <td className="border shadow-inner shadow-blue-400 px-1">
                          {moment(item?.updated_at).format("YYYY/MM/DD")}
                        </td>
                        <td className="border shadow-inner shadow-blue-400 px-1 text-[12px]">
                          <div className="flex row justify-evenly">
                            {item?.token_id}
                            <IoIosCopy
                              onClick={() => handleCopy(item?.token_id)}
                              size={20}
                            />
                          </div>
                        </td>
                        <td className="border shadow-inner shadow-blue-400 px-1">
                          <div className="flex row justify-evenly">
                            {item?.status?.description}
                          </div>
                        </td>
                        <td className="border shadow-inner shadow-blue-400 px-1">
                          <div className="flex justify-center gap-1">
                            <p className="font-semibold">Off</p>
                            <button
                              className="border h-6 w-10 rounded-2xl bg-white shadow-lg border-sky-400"
                              onClick={() => openModal(item.id)}
                            >
                              <div
                                className={
                                  item?.status?.value === "active"
                                    ? "bg-green-500 translate-x-5 duration-200 transition-all rounded-full h-5 w-5"
                                    : "bg-red-500 rounded-full h-5 w-5 translate-x-0.1 duration-200 transition-all"
                                }
                              />
                            </button>
                            <p className="font-semibold">On</p>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Cards */}
              <div className="block md:hidden space-y-2 p-1">
                <div className="flex justify-end md:gap-1 gap-1 text-xs">
                  <span className="font-bold rounded-md shadow-inner shadow-blue-500 p-1">
                    User ID{" "}
                    <p className="font-semibold">
                      {profile?.user_id}
                      <IoIosCopy
                        className="inline text-green-800"
                        onClick={() => handleCopyID(profile?.user_id)}
                        size={16}
                      />
                    </p>
                  </span>
                  <span className="font-bold rounded-md shadow-inner shadow-blue-500 p-1">
                    API Key{" "}
                    <p className="font-semibold">
                      {profile?.api_key}
                      <IoIosCopy
                        className="inline text-green-800"
                        onClick={() => handleCopyKey(profile?.api_key)}
                        size={16}
                      />
                    </p>
                  </span>
                </div>
                {ipAddressData?.map((item, index) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-lg p-1 border shadow-xl shadow-blue-700"
                  >
                    <div className="flex justify-between text-sm">
                      <span className="font-bold">Sno:</span>
                      <span className="font-semibold">
                        {(currentPage - 1) * paginationData?.per_page +
                          index +
                          1}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm mt-2">
                      <span className="font-bold">IP Address:</span>
                      <span>{item?.ip_address}</span>
                    </div>
                    <div className="flex justify-between text-sm mt-2">
                      <span className="font-bold">Created At:</span>
                      <span>
                        {moment(item?.created_at).format("YYYY/MM/DD")}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs mt-2">
                      <span className="font-bold text-sm">Token ID:</span>
                      <div className="flex items-center gap-0">
                        {item?.token_id}
                        <IoIosCopy
                          onClick={() => handleCopy(item?.token_id)}
                          size={16}
                        />
                      </div>
                    </div>
                    <div className="flex justify-between text-sm mt-2">
                      <span className="font-bold">Status:</span>
                      <div className="flex items-center gap-2">
                        <p className="font-semibold">Off</p>
                        <button
                          className="border h-6 w-14 rounded-2xl bg-white shadow-lg border-sky-400"
                          onClick={() => openModal(item.id)}
                        >
                          <div
                            className={
                              item.status.value === "active"
                                ? "bg-green-500 translate-x-8 duration-200 transition-all rounded-full h-6 w-6"
                                : "bg-red-500 rounded-full h-6 w-6 translate-x-0.1 duration-200 transition-all"
                            }
                          />
                        </button>
                        <p className="font-semibold">On</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="flex items-center mt-4 gap-4 text-xl text-neutral-600 justify-center">
              <FaInbox className="text-blue-700" />
              <p className="flex justify-center items-center">Data not found</p>
            </div>
          )}

          <div className="gap-1 mt-1">
            <div className="flex justify-center gap-2">
              <button
                className="py-1 text-xl rounded-md hover:bg-blue-800 px-2 bg-blue-500 text-white border-none cursor-pointer"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <button
                className="py-1 text-xl rounded-md hover:bg-blue-800 px-2 bg-blue-900 text-white border-none cursor-pointer"
                onClick={() =>
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, paginationData?.last_page || 1),
                  )
                }
                disabled={currentPage === paginationData?.last_page}
              >
                Next
              </button>
              <div className="flex justify-end">
                <p className="text-[17px] font-bold">
                  Page {currentPage} of {lastPage}
                </p>
              </div>
            </div>
          </div>
        </>

        {changeKeyClicked && <APIKeyChangeModal isOpen={changeKeyClicked} onClose={() => setChangeKeyClicked(false)}/>}
      </DivTag>
    </>
  );
};
export default WhiteListIP;
